import { createRoot } from "react-dom/client";
import { initSentry } from "./utils/sentry";
import App from "./App";
import "./index.css";

initSentry();

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
